<template>
  <div>
    <v-container class="py-10" id="cloud">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <div class="subtitle" style="color:#0391af">Chancen</div>
          <h2>Entwicklung der Cloud-Nutzung</h2>
          <p>
            Derzeit werden die meisten Anwendungen der Organisationen noch
            überwiegend lokal bereitgestellt. Nur bei etwa <b>21%</b> der
            Organisationen werden überwiegend Cloud-Angebote genutzt. <br />
            Rund <b>40%</b> der Organisationen erwarten aber, dass in zwei
            Jahren überwiegend Cloud-Angebote genutzt werden.
          </p>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                aria-hidden="true"
                v-on="on"
                :to="{ name: 'methodology' }"
              >
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            <span>Stichprobe &amp; Methoden</span>
          </v-tooltip>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" aria-hidden="true">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="download('image/jpeg')">
                <v-list-item-content>
                  <v-list-item-title>JPEG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="download('image/svg+xml')">
                <v-list-item-content>
                  <v-list-item-title>SVG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
                target="blank"
              >
                <v-list-item-content>
                  <v-list-item-title class="pb-2" style="color: #7D9B38"
                    >Lizenzbedingungen</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                aria-hidden="true"
                v-on="on"
                :to="{
                  name: 'comparison',
                  query: { var: 'Cloud Nutzen' }
                }"
              >
                <v-icon>mdi-chart-line</v-icon>
              </v-btn>
            </template>
            <span>Zum Analyse-Tool</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "CloudUse3",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Einschätzung lokal vs. Cloud heute und in zwei Jahren (in %)"
        },
        xAxis: {
          allowDecimals: false,
          categories: [
            "Alles lokal / on-premise",
            "Mehrheitlich lokal",
            "Zu gleichen Teilen",
            "Mehrheitlich in der Cloud",
            "Alles in der Cloud"
          ]
        },
        yAxis: {
          title: {
            text: "Prozent der Organisationen"
          }
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          }
        },

        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: false,
          useHTML: true
        },
        series: [
          {
            name: "... momentan in Ihrer Organisation ein?",
            data: [8.7, 32.0, 22.4, 10.5, 10.6]
          },
          {
            name: "... in 2 Jahren in Ihrer Organisation ein?",
            data: [3.8, 15.8, 21.0, 22.3, 17.6]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Cloud",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
